import { createAsyncThunk } from '@reduxjs/toolkit';

import { IScheduleFullEvent, IUserScheduleData } from '.';
import APIDataProvider, { TApiResponse } from '../../../api/ApiDataProvider';
import { ApiPaths } from '../../../api/APIPaths';
import { TLessonTypes } from '../SectionSlice';

export type TGetUserSchedule = {
  userId: string;
  startDate: string;
  endDate: string;
  courseId?: string;
  studentId?: string;
  tutorId?: string;
  includeCancelledClasses?: boolean;
  lessonType?: TLessonTypes;
};

export type TGetScheduleById = {
  sectionId: string;
};

const apiDataProvider = new APIDataProvider();

const getUserScheduleListModule = async (data: TGetUserSchedule) => {
  let path = `${ApiPaths.schedule}/list/${data.userId}?userId=${data.userId}&startDate=${data.startDate}&endDate=${data.endDate}`;

  if (data.courseId) {
    path += `&courseId=${data.courseId}`;
  }

  if (data.studentId) {
    path += `&studentId=${data.studentId}`;
  }

  if (data.tutorId) {
    path += `&tutorId=${data.tutorId}`;
  }

  if (data.includeCancelledClasses) {
    path += `&includeCancelledClasses=1`;
  }

  if (data.lessonType) {
    path += `&lessonType=${data.lessonType}`;
  }

  const response = await apiDataProvider.get<TApiResponse<IUserScheduleData>>(
    path
  );

  return response.data;
};

export const getUserSchedulesAsUser = createAsyncThunk(
  '/schedule/getByUserId',
  getUserScheduleListModule
);

export const getUserPastSchedulesAsUser = createAsyncThunk(
  '/schedule/getPastByUserId',
  getUserScheduleListModule
);

export const getScheduleByIdAsUser = createAsyncThunk(
  '/schedule/getOneBySectionId',
  async (data: TGetScheduleById) => {
    const path = `${ApiPaths.schedule}/${data.sectionId}?sectionId=${data.sectionId}`;

    const response = await apiDataProvider.get<
      TApiResponse<IScheduleFullEvent>
    >(path);

    return response.data;
  }
);
